import { GridOptions, SideBarDef, StatusPanelDef } from "ag-grid-enterprise";

/** Checkbox multi-select — overrides `DataTable`'s single-row default. */
export const multiRowSelection = {
  mode: "multiRow",
  checkboxes: true,
  headerCheckbox: true
} satisfies GridOptions["rowSelection"];

/** Multi-select where only the checkbox selects — a row click edits or drags. */
export const multiRowSelectionCheckboxOnly = {
  ...multiRowSelection,
  enableClickSelection: false
} satisfies GridOptions["rowSelection"];

/** `multiRowSelectionCheckboxOnly` in a tight pinned column. */
export const multiRowSelectionGridOptions = {
  rowSelection: {
    ...multiRowSelectionCheckboxOnly,
    enableSelectionWithoutKeys: true
  },
  selectionColumnDef: {
    width: 44,
    pinned: "left",
    sortable: false,
    resizable: false,
    suppressHeaderMenuButton: true
  }
} satisfies GridOptions;

/**
 * Single-row mode that nothing selects — `DataTable` enables click selection
 * by default, which highlights a row the user cannot act on. For read-only
 * tables.
 */
export const singleRowSelectionNoClick = {
  mode: "singleRow",
  checkboxes: false,
  enableClickSelection: false
} satisfies GridOptions["rowSelection"];

export const defaultSidebar: {
  sideBar: SideBarDef;
  statusBar: { statusPanels: StatusPanelDef[] };
} = {
  // Side bar
  sideBar: {
    toolPanels: ["columns", "filters"],
    position: "right",
    defaultToolPanel: ""
  },

  // Status bar
  statusBar: {
    statusPanels: [
      {
        statusPanel: "agAggregationComponent",
        statusPanelParams: { aggFuncs: ["avg", "sum", "count"] }
      }
    ]
  }
};

/**
 * Columns + filters sidebar whose panels keep their own layout instead of
 * mirroring the grid's column order (`suppressSyncLayoutWithGrid`), so a
 * consumer can reorder them independently — e.g. alphabetically, grouped by
 * active/inactive — via `sortColumnsToolPanel` / `sortFiltersToolPanel`.
 */
export const sortedSidebar: SideBarDef = {
  position: "right",
  defaultToolPanel: "",
  toolPanels: [
    {
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: { suppressSyncLayoutWithGrid: true }
    },
    {
      id: "filters",
      labelDefault: "Filters",
      labelKey: "filters",
      iconKey: "filter",
      toolPanel: "agFiltersToolPanel",
      toolPanelParams: { suppressSyncLayoutWithGrid: true }
    }
  ]
};
